import tippy from 'tippy.js'
import { constants } from './dropdown.constant'
import { dropDownSelectors } from './dropdown.selector'

export const DropDown = (() => {
	const initDropDown = (dropDownHandler: HTMLElement, onShown: () => void) => {
		const contentId: string | null = dropDownHandler.getAttribute(constants.selector.handler)
		if (!contentId) {
			return
		}

		const template: HTMLElement | null = document.querySelector(`template#${contentId}`)
		if (!template) {
			return
		}

		tippy(dropDownHandler, {
			content: template.innerHTML,
			trigger: 'click',
			placement: 'bottom-end',
			allowHTML: true,
			arrow: true,
			animation: 'scale',
			duration: [250, 200],
			theme: 'light',
			interactive: true,
			onShown() {
				onShown()
			},
		})
	}

	const initDropDowns = (onShown: () => void) => {
		const dropdownsHandlers = dropDownSelectors.getHandlers()

		for (let i = 0; i < dropdownsHandlers.length; i++) {
			initDropDown(dropdownsHandlers[i], onShown)
		}
	}

	const init = (onShown: () => void) => {
		initDropDowns(onShown)
	}

	return {
		init,
	}
})()
